<template>
    <div class="badge-box">
        <span :class="badgeClass" :style="badgeStyle">
            <span v-if="shape !='dot'" class="line-break">
                <slot>
                    {{text}}
                </slot>
            </span>
        </span>
        <span v-if="shape ==='dot'" class="line-break" style="margin-left: 8px;">
            <slot>
                {{text}}
            </slot>
        </span>
    </div>
</template>

<script>
    // ur-badge는 알림의 용도로 주로 사용되는 컴포넌트로써, text props의 값으로 전달된 문자열을 돋보이게 보여주는 역할을 수행합니다.
    // #ur-badge is used for simple information to you.
    // #It can define the text props, more easily check information.

    export default {
        name: "ur-badge",
        data () {
            return{
            }
        },
        props: {
            // $ver: v0.1.0
            // Badge에 표시되는 숫자나 문자열값 입니다. Dot 형태의 뱃지인 경우 값을 입력해도 표시되지 않습니다.
            // #The number or string value displayed on the badge. If the badge is a dot, it will not display even if you enter a value
            // $default: null
            // $tags: IDE
            text: {
                type: [String,Number],
                default: null,
            },
            // $ver: v0.1.0
            // 색상입니다. 사전에 정의된 색상 문자열만 입력 가능합니다.
            // ('primary', 'success', 'error', 'default', 'processing', 'warning')
            // #Color. Only predefined color strings can be entered.
            // #('primary', 'success', 'error', 'default', 'processing', 'warning')
            // $default: primary
            // $tags: IDE
            color: {
                type: String,
                default: 'primary',
            },
            // $ver: v0.1.0
            // 유형입니다. 사전에 정의된 유형 문자열만 입력 가능합니다.
            // ('status', 'identifier', 'dot')
            // #Type. Only predefined type strings can be entered.
            // #('status', 'identifier', 'dot')
            // $tags: IDE
            shape: {
                type: String,
                default: 'status',
            },

        },
        computed: {
            badgeClass() {
                let clazz = [];
                clazz.push('ur-badge');
                clazz.push('ur-badge__' + this.shape);
                clazz.push('ur-badge__badge-color-primary');
                clazz.push('ur-badge__badge-color-' + this.color);
                return clazz;
            },
            badgeStyle() {
                let style = {};

                if (this.shape === 'dot') {
                    style['width'] = '8px';
                    style['height'] = '8px';
                    style['display'] = 'inline-block';
                    style['vertical-align'] = 'middle';
                } else if (this.text && this.text.length === 1) {
                    style['width'] = '16px';
                } else {
                    style['padding-left'] = '8px';
                    style['padding-right'] = '8px';
                    style['width'] = '100%';
                    style['height'] = '100%';
                    style['display'] = 'flex';
                    style['align-items'] = 'center';
                    style['justify-content'] = 'center';
                }

                return style;
            }
        }
    }
</script>

